import {
  CreateExerciseTagCommand,
  ICreateExerciseTagCommand,
  IUpdateExerciseTagCommand,
  LibrarySort,
  UpdateExerciseTagCommand,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";
import { exerciseTagsClient } from "../api/ApiClients";

class ExerciseTagsService extends ServiceBase {
  async getAllExerciseTags() {
    return exerciseTagsClient.getExerciseTags();
  }

  async getExerciseTags(
    page: number,
    pageSize: number,
    query?: string,
    orderBy: LibrarySort = LibrarySort.NAME_ASC,
  ) {
    return exerciseTagsClient.getExerciseTagsWithPagination(
      page,
      pageSize,
      query,
      orderBy,
    );
  }

  async createExerciseTag(variables: ICreateExerciseTagCommand) {
    const command = new CreateExerciseTagCommand(variables);
    return exerciseTagsClient.createExerciseTag(command);
  }

  async updateExerciseTag(variables: IUpdateExerciseTagCommand) {
    const command = new UpdateExerciseTagCommand(variables);
    return exerciseTagsClient.updateExerciseTag(command.id, command);
  }

  async deleteExerciseTag(id: number) {
    return exerciseTagsClient.deleteExerciseTag(id);
  }
}

export default new ExerciseTagsService();
